import React, { Fragment, useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router";
import FBannerSpend from "../../components/FspendComponents/FBannerSpend/FBannerSpend";
import FBoxContainer from "../../components/FBoxContainer/FBoxContainer";
import FCategoryContainer from "../../components/FCategoryContainer/FCategoryContainer";
import { useBillPaymentArcus } from "../../hooks/useBillPaymentArcus";
import { getPublicServices } from "../../api/spend";
import { AuthContext } from "../../context/AuthContext";

const BillPaymentScreen = ({ param }) => {
  const route = useNavigate();
  const { setLoading,checkToken } = useContext(AuthContext);
  const [publicServices, setPublicServices] = useState([]);
  const [sortedCategories, setSortedCategories] = useState([]);
  const { goToTransactionCustomizationScreen } = useBillPaymentArcus();

  const action = (product) => {
    goToTransactionCustomizationScreen(product);
  };

  const getPublicService = async () => {
    checkToken()
    try {
      setLoading(true);
      const { data } = await getPublicServices();
      setLoading(false);
      setPublicServices(data.data);
    } catch (e) {
      setLoading(false);
      //console.log(e.response?._response);
    }
  };

  useEffect(() => {
    getPublicService();
  }, []);

  useEffect(() => {
    sortCategories(publicServices);
  }, [publicServices]);

  const sortCategories = (items) => {
    let sort = items.sort((a, b) => {
      if (a.categoryId == "Más Usados") {
        return -1;
      }
      if (a.sortingPosition > b.sortingPosition) {
        return 1;
      }
    });

    setSortedCategories(sort);
  };

  return (
    <>
      <FBannerSpend
        imageUrl={require("../../components/assets/images/recharge.png")}
        title="Servicios Públicos"
        description="Saldo Disponible"
      />
      <div className="mb-16">
        <FBoxContainer sortedCategories={sortedCategories} action={action} />
      </div>
    </>
  );
};

export default BillPaymentScreen;
